export default __webpack_public_path__ + "static/media/SignalOnlyAnnotations.3142029d.png";